import React, { useState, useEffect, useRef } from "react";
import "./PgmList.scss";
import Sidebar from "../Sidebar";
import { pgmlistAction } from "../../actions/pgmlistAction";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { decode, encode } from "base-64";
import Header from "../../component/loaderComponent/Header/Header";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Nopermission from "../../component/loaderComponent/NoPermissions/Nopermission";
import Cookies from "js-cookie";
import { notify } from '../../services/notification';
import Validation from "../../constants/validation/Validation";
import { useSelector } from "react-redux";
import { categoryAction, pgmpageAction } from "../../actions/pgmlistAction";
import { searchCriteriaAction } from "../../actions/pgmlistAction";
import NoDataFound from "../../component/noDataComponent/NoDataFound";
import { dowloadpgmlistAction } from "../../actions/exceldownloadAction";
import PgmListSkeleton from "../../component/SkeletonLoader/PgmListSkeleton";
import { HiMenu, HiX } from "react-icons/hi";
import useMobileView from "../../constants/useMobileView";
import { formatDate } from "../../constants/validation/FormateDate";
// Bulk Approvall Disabled
// import { putadminverifyAction } from "../../actions/pgmlistAction";
// import { useParams } from 'react-router-dom';
import { constant } from "../../constants/constant";
import { isMoreThanThreeMonths } from "../../constants/dateTimeUtils/dateTimeUtils";

function PgmList(props) {

  const [state, setDataState] = useState({
    pgmdata: [],
    // Bulk Approvall Disabled
    // pgm_status: ""
  });
  const categorydata = useSelector((state) => state.pgmCategory);
  const searchdata = useSelector((state) => state.pgmSearch);
  const { isSidebarOpen, toggleSidebar } = useMobileView();
  const [states, setDataStates] = useState({
    nameValue: searchdata?.searchdata?.data?.value
  })
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(categorydata.page);
  const dispatch = useDispatch();
  const [fromDate, setFromDate] = useState(searchdata?.searchdata?.data?.fromDate);
  const [toDate, setToDate] = useState(searchdata?.searchdata?.data?.toDate);

  const [criteria, setcriteria] = useState(searchdata?.searchdata?.data?.criteria ? searchdata?.searchdata?.data?.criteria : "");
  const [activeStatus, setActiveStatus] = useState("all");
  const [activeButton, setActiveButton] = useState("all");
  const [isLoading, setLoading] = useState(false);
  // Bulk Approvall Disabled
  // const [isLoading, setIsLoading] = useState(false);
  // const [selectall, setSelectAll] = useState(false);
  // const [selectedPgm, setSelectedPgm] = useState([]);
  const [nodata, setNodata] = useState(false);
  const [paginationListcount, setpaginationListcount] = useState(0);
  const data = decode(Cookies.get('permissions'));
  const permissions = data?.includes("pgm_registration_approval");

  const navigate = useNavigate();
  const isInitialMount = useRef(true);
  const prevPage = useRef(page);
  const prevStatus = useRef(activeStatus);

   useEffect(() => {
    return () => {
      dispatch(searchCriteriaAction(null));
    };
  }, []);

  // Consolidated useEffect to prevent multiple API calls
  useEffect(() => {
    if (isInitialMount.current) {
      // On initial mount, fetch data only once
      isInitialMount.current = false;
      PgmListData(activeStatus);
      prevPage.current = page;
      prevStatus.current = activeStatus;
      return;
    }

    // Check what changed
    const pageChanged = prevPage.current !== page;
    const statusChanged = prevStatus.current !== activeStatus;

    // Fetch data if page or status changed
    // Dates trigger API only via Search button
    if (pageChanged || statusChanged) {
      PgmListData(activeStatus);
    }

    // Update refs
    prevPage.current = page;
    prevStatus.current = activeStatus;
  }, [page, activeStatus]); // Dates trigger API only via Search button

  async function handleCriteriaChange(event) {
    dispatch(pgmpageAction(1));
    setDataStates({
      ...states,
      nameValue: '',
    });
    setcriteria(event.target.value)
    setPage(1);
    var seardata = {
      criteria: event.target.value,
      value: "",
    };
    dispatch(searchCriteriaAction(seardata));
    // var response = await dispatch(pgmlistAction(page, activeStatus));
    // if (response == 200 || response != null) {
    //   setNodata(true);
    //   if (response.data.count % 10 == 0) {
    //     setCount(Math.floor(response.data.count / 10))
    //   }
    //   else {
    //     setCount(Math.floor((response.data.count / 10) + 1))
    //   }
    //   setDataState({
    //     pgmdata: response.data.results.data,
    //   });
    // }
  }

  const handleChange = (evt) => {
    const value = evt.target.value;
    setDataStates({
      ...states,
      [evt.target.name]: value.replace(/^ +/gm, ''),
    });
    if (value.length === 0) {
      window.location.reload()
    }
  };


  const pgmDetails = (Id) => {
    window.scroll(0, 0);
    const encodeid = encode(Id);
    navigate(`/pgmdetails/${encodeid}`);
  };


  const handleClick = (para) => {
    dispatch(categoryAction(para));
    dispatch(pgmpageAction(constant.defaultPage));
    setPage(1);
    setActiveStatus(para);
    setActiveButton(para);
  };
  async function PgmListData(para) {
    setLoading(true);
    if ((!criteria || !states.nameValue) && (!fromDate || !toDate)) {
      var response = await dispatch(pgmlistAction(page, para));

    } else {
      var response = await dispatch(pgmlistAction(page, para, states.nameValue, criteria, fromDate, toDate));
    }
    if (response == 200 || response != null) {
      setLoading(false);
      setNodata(true);
      if (response.data.count % 10 == 0) {
        setCount(Math.floor(response?.data?.count / 10))
      }
      else {
        setCount(Math.floor((response?.data?.count / 10) + 1))
      }
      await setDataState({
        pgmdata: response?.data?.results?.data,
      });
      setpaginationListcount(response.data.count)
    }
  }
  const startItem = state?.pgmdata?.length === 0 ? 0 : (page - 1) * constant.paginationCount + 1;
  const endItem = Math.min(page * constant.paginationCount, paginationListcount);

  const handlePagiChange = (event, value) => {
    dispatch(pgmpageAction(value));
    setPage(value);
  };

  async function filterSearch() {
    setLoading(true);
    if ((!criteria || !states.nameValue) && (!fromDate || !toDate)) {
      notify.error('Please select either criteria or both From and To dates.');
      setLoading(false);
      return;
    }
    var seardata = {
      criteria: criteria,
      value: states.nameValue,
      fromDate,
      toDate,
    };
    dispatch(searchCriteriaAction(seardata));
    let response = await dispatch(pgmlistAction(page, activeStatus, states.nameValue, criteria, fromDate, toDate));
    if (response == 200 || response != null) {
      setLoading(false);
      setNodata(true);
      if (response.data.count % 10 == 0) {
        setCount(Math.floor(response.data.count / 10))
      }
      else {
        setCount(Math.floor((response.data.count / 10) + 1))
      }
      setDataState({
        pgmdata: response.data.results.data,
      });
      setpaginationListcount(response.data.count);
    }
  }


  async function downloadpgmlist() {
    try {
      if (!isMoreThanThreeMonths(fromDate, toDate)) {
        notify.error("Date range cannot exceed 3 months");
        return;
      }
      const fileBlob = await dispatch(dowloadpgmlistAction(page, activeStatus, states.nameValue, criteria, fromDate, toDate));
      if (fileBlob) {
        const messageText = await fileBlob.text();
        const jsonText = JSON.parse(messageText);
        notify.success(jsonText.message || 'Success');
      }
    } catch (error) {
      notify.error('Error downloading file:', error);
    }
  }
  // Bulk Approvall Disabled
  // useEffect(() => {
  //   if (selectall) {
  //     let arr = state?.pgmdata?.map((item) => item?.id) || []
  //     setSelectedPgm(arr);
  //   }
  //   else {
  //     setSelectedPgm([]);
  //   }
  // }, [selectall])

  // const handleSelectAll = () => {
  //   const selectAllChecked = !selectall;
  //   setSelectAll(selectAllChecked);
  //   if (selectAllChecked) {
  //     let arr = state?.pgmdata?.map((item) => item?.id) || [];
  //     setSelectedPgm(arr);
  //   } else {
  //     setSelectedPgm([]);
  //   }
  // };

  // const handleCheckboxChange = (id) => {
  //   const selectedIndex = selectedPgm.indexOf(id);
  //   let newSelected = [];

  //   if (selectedIndex === -1) {
  //     newSelected = newSelected.concat(selectedPgm, id);
  //   } else if (selectedIndex === 0) {
  //     newSelected = newSelected.concat(selectedPgm.slice(1));
  //   } else if (selectedIndex === selectedPgm.length - 1) {
  //     newSelected = newSelected.concat(selectedPgm.slice(0, -1));
  //   } else if (selectedIndex > 0) {
  //     newSelected = newSelected.concat(
  //       selectedPgm.slice(0, selectedIndex),
  //       selectedPgm.slice(selectedIndex + 1)
  //     );
  //   }

  //   setSelectedPgm(newSelected);
  // };

  // const onApprove = async (id) => {
  //   let apiReq = {
  //     "ids": [id],
  //     "pgm_status": "Approved"
  //   };
  //   setIsLoading(true);
  //   let response = await dispatch(putadminverifyAction(apiReq));
  //   if (response && response.status === 200) {
  //     setIsLoading(false);
  //     notify.success(response.data.message);
  //     setSelectedPgm([]); // Clear the selectedPgm state
  //     window.location.reload(); // Reload the page
  //   } else {
  //     notify.error(response.data.message);
  //   }
  // };

  // const onReject = async (id) => {
  //   let apiReq = {
  //     "ids": [id],
  //     "pgm_status": "Rejected"
  //   };
  //   let response = await dispatch(putadminverifyAction(apiReq));
  //   if (response && response.status === 200) {
  //     notify.success(response.data.message);
  //     setSelectedPgm([]); // Clear the selectedPgm state
  //     window.location.reload(); // Reload the page
  //   } else {
  //     notify.error(response.data.message);
  //   }
  // };
  const DELETED_STATUS = "Deleted";

  const today = formatDate(new Date());

  return (

    <div className="PgmConatiner">
      {/* <div className={`pgm-container ${isSidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="mobile-header">
          <button className="hamburger-button" onClick={toggleSidebar}>
            {isSidebarOpen ? (
              <HiX className="hamburger-icon" size={24} />
            ) : (
              <HiMenu className="hamburger-icon" size={24} />
            )}
          </button>
        </div>

        <div className={`sidebar-overlay ${isSidebarOpen ? 'active' : ''}`} onClick={toggleSidebar}></div>
        <div className={`sidebar-container ${isSidebarOpen ? 'open' : ''}`}>
          <Sidebar />

        </div>
      </div> */}
      <div className="pgmlistcontainer">
        <div className="pgm_list_container_s">
          <Header title="PGM List" />
          <span className="pgm_note">
            Note: Select the 'All' tab for the full PGM list. Enter the date range and click Search. Wait for results to load, then click Download Excel.
          </span>
          {isLoading ? (
            <PgmListSkeleton />
          ) : (
            <>
              {permissions === true ?
                <div className="Pgmmargin_div">
                  <div className="pgmbutton">
                    <div className="button-group-pgmlist">
                      <button className={activeButton === "all" ? "active pgm_buttonAll " : "pgm_buttonAll"} onClick={() => handleClick("all")} > All </button>
                      <button className={activeButton === "Pending" ? "active pgm_buttonPendings" : "pgm_buttonPendings"} onClick={() => handleClick("Pending")}> Pending </button>
                      <button className={activeButton === "approved" ? "active pgm_buttonApproved" : "pgm_buttonApproved"} onClick={() => handleClick("approved")}> Approved </button>
                      <button className={ activeButton === "rejected" ? "active pgmbuttonRejects" : "pgmbuttonRejects" } onClick={() => handleClick("rejected")}>Rejected</button>
                      <button className={ activeButton.toLowerCase() === "deleted" ? "active pgmbuttonDelete" : "pgmbuttonDelete" } onClick={() => handleClick(DELETED_STATUS)} > Deleted </button>
                    </div>
                      <button className="download_excel" onClick={downloadpgmlist} disabled={state.pgmdata?.length === 0 || !fromDate || !toDate }> <img src={Image_Url.EXCEL_LOGO} className="downloads_imgdexcel" /> Download Excel </button>
                  </div>
                  <div className="textfield_dropdown">
                    <select name="criteria" id="cars" className="text_fileddropdowns" value={criteria} onChange={handleCriteriaChange}>
                      <option value="">Select Criteria</option>
                      <option value="name">Name</option>
                      <option value="mobile_number">Mobile Number</option>
                      <option value="pincode">Pincode</option>
                      <option value="garage_name">Shop Name</option>
                      <option value="pgm_id">PGM ID</option>
                      <option value="msr_id">MSR ID</option>
                    </select>
                    {criteria === "pincode" ? (
                      <input
                        type="search"
                        className="pgmlist-input-field"
                        placeholder="Enter a Value"
                        name="nameValue"
                        maxLength={6}
                        value={states.nameValue}
                        disabled={!criteria}
                        onChange={handleChange}
                        onKeyPress={(e) => Validation.numberinputValidator(e)}
                      />
                    ) : criteria === "mobile_number" ? (
                      <input
                        type="search"
                        className="pgmlist-input-field"
                        placeholder="Enter a Value"
                        name="nameValue"
                        maxLength={10}
                        value={states.nameValue}
                        disabled={!criteria}
                        onChange={handleChange}
                        onKeyPress={(e) => Validation.numberinputValidator(e)}
                      />
                    ) : (
                      <input
                        type="search"
                        className="pgmlist-input-field"
                        placeholder="Enter a Value"
                        name="nameValue"
                        disabled={!criteria}
                        value={states.nameValue}
                        onChange={handleChange}
                      />
                    )}
                    <div>
                      <div className="from-to-date">
                        <div className="date-container">
                          <label className="date-label">
                            From Date<span className="required">*</span>
                          </label>
                          <input
                            type="date"
                            id="date"
                            value={fromDate}
                            max={toDate ? toDate : today}
                            placeholder="dd/mm/yy"
                            onChange={(e) => setFromDate(e.target.value)}
                            name="fromDate"
                            className="pgmlist-date-input-field"
                          />
                        </div>
                        <div className="date-container">
                          <label className="date-label">
                            To Date<span className="required">*</span>
                          </label>
                          <input
                            type="date"
                            id="date"
                            min={fromDate}
                            max={today}
                            value={toDate}
                            placeholder="dd/mm/yy"
                            onChange={(e) => setToDate(e.target.value)}
                            name="toDate"
                            className="pgmlist-date-input-field"
                            disabled={!fromDate}
                          />
                        </div>
                      </div>
                    </div>
                    <button className="pgm_buttonsearchs"
                      disabled={
                        !(
                          (criteria && states.nameValue) || (fromDate && toDate)
                        )
                      }
                      onClick={filterSearch}>Search</button>
                  </div>
                  <div className="tabledata">
                    {state.pgmdata?.length > 0 ?
                      <div>
                        <table className="table">
                          <tr>
                            {/* <th className="tablesth"> */}
                            {/* Bulk Approvall Disabled */}
                            {/* {activeStatus === 'Pending' && (
                              <input
                                type="checkbox"
                                className="pgmlist-checkbox"
                                checked={selectall}
                                onChange={handleSelectAll}
                              />
                            )} */}
                            {/* </th> */}

                            <th className="tablesth">PGM Name</th>
                            <th className="tablesth">Mobile Number</th>
                            <th className="tablesth">Pincode</th>
                            <th className="tablesth">Shop Name</th>
                            <th className="tablesth">Status Reason</th>
                            <th className="tablesth">Created On</th>
                            <th className="tablesth">Registered On</th>
                            <th className="tablesth">Location</th>
                            <th className="tablesth">Action</th>
                          </tr>
                          {state.pgmdata?.map((item, index) => {
                            return (
                              <tr>
                                {/* Bulk Approval Disabled */}
                                {/* <td className="tabletd-pgmlist">
                                {activeStatus === 'Pending' && (
                                  <input
                                    type="checkbox"
                                    className="pgmlist-checkbox"
                                    checked={selectedPgm?.includes(item?.id)}
                                    onChange={() => handleCheckboxChange(item?.id)}
                                  />
                                )}
                              </td> */}

                                <td className="tabletd-pgmlist" key={index}>{item.name}</td>
                                <td className="tabletd-pgmlist-mobile">{item.mobile_number}</td>
                                <td className="tabletd-pgmlist">{item.pincode}</td>
                                <td className="tabletd-pgmlist">{item.garage_name}</td>
                                <td className="tabletd-pgmlist">{item?.status_reason ?? "--------"}</td>
                                <td className="tabletd-pgmlist">{item?.created_on}</td>
                                <td className="tabletd-pgmlist">{item?.registered_on}</td>
                                <td className="tabletd-pgmlist">{item.state_name}</td>
                                <td className="tabletdV">
                                  <div className="card_profile_controls">
                                    <img
                                      src={Image_Url.EDIT}
                                      className="edit_icons"
                                      onClick={() => {
                                        pgmDetails(item.id);
                                      }}
                                    />
                                  </div>

                                </td>
                              </tr>
                            );
                          })}
                        </table>
                      </div>
                      :
                      <div>
                        {nodata && (<NoDataFound />)}
                      </div>
                    }
                    {/* Bulk Appproval Disabled */}
                    {/* <div className="button-approve-reject">
                    <button
                      className="button-approve"
                      type="button"
                      disabled={state.pgmdata?.pgm_status === "Approved"}
                      onClick={() => onApprove(selectedPgm[0])}
                    >
                      Approve
                    </button>

                    <button
                      className="button-reject"
                      type="button"
                      disabled={state.pgmdata?.pgm_status === "Rejected"}
                      onClick={() => onReject(selectedPgm[0])}
                    >
                      Reject
                    </button>
                  </div> */}
                  </div>
                  <div className="Pagination_section">
                    <Stack spacing={2}>
                      <Pagination
                        count={count}
                        className="pagination"
                        page={page}
                        size="medium"
                        defaultPage={1}
                        color="primary"
                        onChange={handlePagiChange}
                      />
                    </Stack>
                    <div className="count">
                      <b>
                        <span>Displaying {startItem} to {endItem} out of {paginationListcount}</span>
                      </b>
                    </div>
                  </div>
                </div>
                : (
                  <Nopermission />
                )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
export default PgmList;